export const noop = () => {};

/** @param {number} index  */
export const getA11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
});

export const tabStyles = {
    height: 'calc(100% - 48px)',
    overflow: 'auto',
}
